// BUSINESS DESK — client API (token session, erreurs FR, format FCFA).
const API = process.env.REACT_APP_BACKEND_URL || "";
const KEY = "desk_token";

export const getToken = () => sessionStorage.getItem(KEY);
export const setToken = (t) => sessionStorage.setItem(KEY, t);
export const clearToken = () => sessionStorage.removeItem(KEY);

export async function deskApi(path, { method = "GET", body, idempotency } = {}) {
  const headers = { "Content-Type": "application/json" };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  if (idempotency) headers["Idempotency-Key"] = idempotency;
  const r = await fetch(`${API}/api/v3/desk${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await r.json().catch(() => ({}));
  if (r.status === 401) {
    clearToken();
    const e = new Error(data.message || "Session expirée");
    e.code = "LOCKED";
    throw e;
  }
  if (!r.ok || data.ok === false) {
    const e = new Error(data.message || "Une erreur est survenue");
    e.code = data.error || "ERROR";
    throw e;
  }
  return data;
}

export const pdfUrl = (documentId) => `${API}/api/v3/desk/documents/${documentId}/pdf?t=${getToken()}`;

export const fmtF = (minor) => `${new Intl.NumberFormat("fr-FR").format(minor || 0)} FCFA`;

export const newIdempotencyKey = () =>
  (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const TYPE_LABEL = { QUOTE: "Devis", INVOICE: "Facture", PAYMENT_RECEIPT: "Reçu" };
export const STATUS_LABEL = { DRAFT: "Brouillon", VALIDATED: "Validé", ISSUED: "Émis", CANCELLED: "Annulé" };
